import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";
//import "./dark/index.scss";

import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import './i18n/config';
import { createRoot } from 'react-dom/client';
document.body.className = 'light';
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App/>);
//ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
